// ===========================================================================
// LOCAL DEBUG ONLY — gitignored, do NOT push.
// Turns on the aim cues the game works out but doesn't show: the target circle on
// Mars's arrival spot, the arc going to the warning colour when the launch is
// aimed against Earth's motion, and a green band covering every launch that would
// meet Mars. All of them hand the player the answer, which is why they're off in
// the real game.
//
// The band is not drawn from a formula: it walks the drag, every direction against
// every force, asks the game itself (aimWouldRendezvous) which of them would meet
// Mars, and draws those paths. What you see is the overlap of them, so it can never
// disagree with the game, and it moves the moment aimArc, ship speed or the target
// circle is retuned (the trajectory debug panel does exactly that).
//
// Self-activating: js/index.js picks every *Debug.js up on its own, so just load
// the page with ?aimDebug. It reads the game off window.app.game.
// ===========================================================================

const SVG_NS = "http://www.w3.org/2000/svg";
const ZONE_ID = "aim-debug-zone";

// How finely the drag is walked: sideways (the launch direction) and up-down (the
// force). Fine enough that the paths that survive overlap into a solid band, coarse
// enough not to put thousands of arcs in the SVG.
const ZONE_TURN_STEPS = 200;
const ZONE_FORCE_STEPS = 100;

// Draw the band of launches that would meet Mars, behind the real aim path. Needs
// the travel distance and the target circle the press sets up, so it can only be
// built once aiming has started.
function drawGoodZone(game) {
  const solarSystem = game.solarSystem;
  const layer = document.querySelector("#trajectory-layer");
  if (!layer || solarSystem.rendezvousTravel == null) return;

  const zone = document.createElementNS(SVG_NS, "g");
  zone.setAttribute("id", ZONE_ID);

  for (let i = 0; i <= ZONE_TURN_STEPS; i++) {
    const turn = -1 + (2 * i) / ZONE_TURN_STEPS;
    const aim = solarSystem.aimVectorFor(turn);

    for (let j = 0; j <= ZONE_FORCE_STEPS; j++) {
      const force = j / ZONE_FORCE_STEPS;
      if (!game.aimWouldRendezvous(aim, force)) continue;

      const geo = solarSystem.aimGeometry(aim.x, aim.y, force);
      const path = document.createElementNS(SVG_NS, "path");
      // Drawn only as far as the meeting point, so the band ends on Mars rather
      // than trailing off round the far side with the rest of the path.
      path.setAttribute("d", solarSystem.trajectoryPathD(geo, solarSystem.rendezvousTravel));
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "#3ddc84");
      path.setAttribute("stroke-width", "3");
      path.setAttribute("stroke-opacity", "0.15");
      zone.appendChild(path);
    }
  }

  // First in the layer, so the aim path and the markers stay drawn over it.
  layer.insertBefore(zone, layer.firstChild);
}

// Put the band up while aiming and take it down at launch. Redrawn whenever it has
// gone missing, which covers a reset rebuilding the whole trajectory layer.
function trackAim(game) {
  const updateAim = game.updateAim.bind(game);
  game.updateAim = () => {
    updateAim();
    if (!document.getElementById(ZONE_ID)) drawGoodZone(game);
  };

  const launchTransfer = game.launchTransfer.bind(game);
  game.launchTransfer = (result) => {
    document.getElementById(ZONE_ID)?.remove();
    launchTransfer(result);
  };
}

function enable(game) {
  const solarSystem = game.solarSystem;
  solarSystem.showTargetRing = true;
  solarSystem.markUpstream = true;
  trackAim(game);

  // An aim may already be on screen, so redraw it through the normal path rather
  // than reaching for the classes here.
  if (solarSystem.aimGeo && typeof game.updateAim === "function") game.updateAim();

  // eslint-disable-next-line no-console
  console.log("aim debug on: target circle shown, upstream aims marked in colour, good launches banded in green");
}

function init() {
  if (!new URLSearchParams(window.location.search).has("aimDebug")) return;
  const tryAttach = () => {
    const game = window.app && window.app.game;
    if (!game || !game.solarSystem) return setTimeout(tryAttach, 200);
    enable(game);
  };
  tryAttach();
}

init();
